import { render, staticRenderFns } from "./orderStats.vue?vue&type=template&id=1e16313c"
import script from "./orderStats.vue?vue&type=script&lang=js"
export * from "./orderStats.vue?vue&type=script&lang=js"
import style0 from "../assets/css/offer.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./orderStats.vue?vue&type=style&index=1&id=1e16313c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports